<template>
  <modal title="" width="40" :showModal="showModal" @close-modal="closeModal">
    <div class="">
      <div class="text-center">
        <div class="flex justify-center">
          <img
            src="@/assets/images/ondemand/disconnected 1.svg"
            alt="cancel icon"
            class="mb-3"
          />
        </div>
        <div>
          <p>Are you sure you want to cancel?</p>
        </div>
      </div>

      <div class="py-6 pb-3 w-full">
        <div class="flex items-center">
          <el-select
            filterable
            class="w-full"
            v-model="payload.reason"
            placeholder="--Tell us why you’re cancelling--"
          >
            <el-option
              v-for="reason in [
                'Wrong pick-up location',
                'Package not ready',
                'Customer changed mind',
                'On customer request',
                'Other',
              ]"
              :key="reason"
              :label="reason"
              :value="reason"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="py-5" v-if="payload.reason == 'Other'">
        <label class="label">Reason for Cancellation.</label>
        <textarea
          v-model="payload.message"
          :disabled="payload.reason != 'Other'"
          class="text-area"
          placeholder="Text Area"
        ></textarea>
      </div>
      <div class="my-3">
        <p class="text-sm py-0">
          <span class="text-primary-yellow">*</span>
          Please note that cancellation is only applicable for bookings that are
          yet to commence. MuleEx will refund for cancelled bookings, but will
          charge you a flat cancelation fee of N750.
        </p>
      </div>
      <div class="flex justify-between pt-4">
        <base-button
          text="Go Back"
          background="bg-white"
          border="border border-darkBlue"
          @click="closeModal"
        />
        <base-button
          text="Yes, Cancel"
          :loading="loading"
          @click="cancelBooking"
        />
      </div>
    </div>
    <ConfirmCancellation
      :showModal="showConfirmCancellationModal"
      @close-modal="showConfirmCancellationModal = false"
    />
  </modal>
</template>

<script>
import ConfirmCancellation from "./ConfirmCancellation.vue";

export default {
  components: { ConfirmCancellation },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showConfirmCancellationModal: false,
      disableText: false,
      loading: false,
      reason: "",
      payload: {
        reason: "",
        deliveryStatus: "cancelled",
        message: "",
      },
    };
  },
  watch: {
    "payload.message"(val) {
      if (val == "others") {
        this.disableText = false;
      } else this.disableText = true;
    },
  },
  computed: {
    getMessage() {
      return "";
    },
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async cancelBooking() {
      this.loading = true;
      try {
        await this.$_cancelShippment(this.shipping.id, this.payload);
        this.loading = false;
        this.generateToast("Booking cancelled successfully", "success");
        this.showConfirmCancellationModal = true;
        this.$emit('refresh')
         setTimeout(() => {
          this.closeModal()
         }, 1000);
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
textarea:disabled {
  opacity: 0.5;
}
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
.el-select {
  width: w-full;
}
.text-area {
  display: block;
  width: 100%;
  height: 8rem;
  background: #f6f8f9;
  padding: 1em;
  border: 0.5px solid #9ba0a7;
  border-radius: 3px;
}
</style>
